// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"305":"1b369f0d71b1d31bab70","501":"7e4be5eabd31dee92164"}[chunkId] + ".js";
};